function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "iconCategory5");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Frame_-_24px"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}));

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  id: "Shape",
  points: "10.8333333 8.33333333 10.8333333 0 7.5 0 7.5 8.33333333 9.16666667 6.66666667"
});

var SvgIconBinders = function SvgIconBinders(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, /*#__PURE__*/React.createElement("g", {
    id: "Academy-New-concept",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-130.000000, -581.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dooer-Academy-V2-Copy-2",
    transform: "translate(100.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu",
    transform: "translate(0.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-items",
    transform: "translate(0.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Not-expanded",
    transform: "translate(30.000000, 260.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-item",
    transform: "translate(0.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content-bookmark-1"
  }, _ref5, /*#__PURE__*/React.createElement("g", {
    id: "Filled_Icons",
    transform: "translate(3.333333, 1.666667)",
    fill: "#999",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.833333)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999"
    },
    d: "M3.33333333,0 L0.833333333,0 C0.3725,0 0,0.373333333 0,0.833333333 L0,15 C0,15.46 0.3725,15.8333333 0.833333333,15.8333333 L3.33333333,15.8333333 L3.33333333,0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999"
    },
    d: "M12.5,0 L11.6666667,0 L11.6666667,7.5 C11.6666667,7.83666667 11.4633333,8.14083333 11.1525,8.27 C11.0491667,8.31333333 10.9408333,8.33333333 10.8333333,8.33333333 C10.6166667,8.33333333 10.4033333,8.24833333 10.2441667,8.08916667 L9.16666667,7.0125 L8.08916667,8.09 C7.93,8.24916667 7.71666667,8.33333333 7.5,8.33333333 C7.3925,8.33333333 7.28416667,8.3125 7.18083333,8.27 C6.87,8.14083333 6.66666667,7.8375 6.66666667,7.5 L6.66666667,0 L5,0 L5,15.8333333 L12.5,15.8333333 C12.9608333,15.8333333 13.3333333,15.46 13.3333333,15 L13.3333333,0.833333333 C13.3333333,0.374166667 12.9608333,0 12.5,0 Z"
  })), _ref6))))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconBinders, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-binders.60c4ec95.svg";
export { ForwardRef as ReactComponent };